const SEND_EMAIL_START = 'SEND_EMAIL_START';
const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
const SEND_EMAIL_ERROR = 'SEND_EMAIL_ERROR';

const sendEmailStart = (email, history) => {
	return {
		type: SEND_EMAIL_START,
		email,
		history
	};
};

const sendEmailSuccess = (res = null) => {
	return {
		type: SEND_EMAIL_SUCCESS,
		res,
	};
};

const sendEmailError = () => {
	return {
		type: SEND_EMAIL_ERROR,
	};
};

export default {
	types: {
		SEND_EMAIL_START,
		SEND_EMAIL_SUCCESS,
		SEND_EMAIL_ERROR,
	},
	creators: {
		sendEmailStart,
		sendEmailSuccess,
		sendEmailError,
	},
};
